import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Statistic } from "antd";
import useJDStore from "../../store/jd.store";
import "./evaluationsBank.scss";
import useQCEStore from "../../store/qce.store";
import useGlobalQCEStore from "../../store/globalqce.store";
import EvaluationsBankFilterSidebarForm from "../evaluationsBankFilterSidebarForm";
import EvaluationBankQuestionsCardList from "../evaluationsBankQuestionsCardList";

export default function EvaluationsBank({
  setView,
  exist,
  qhjid,
  ev_id,
  evalDesc,
  globalEvaluationPage = false,
}) {
  const { getQuestionBankForJD, getQuestionBankForJDStats, totalQ } =
    useQCEStore();
  const { getGlobalQuestionBank } = useGlobalQCEStore();
  const [localQSet, setLocalQSet] = useState([]);
  const [qBankStats, setQBankStats] = useState({});
  const [localQDescDeletedList, setLocalQDeletedSet] = useState([]);
  const [qbCount, setQbCount] = useState(totalQ);
  const [sSkill, setSkill] = useState(["all"]);
  const [sAssessmentType, setAssessmentType] = useState(["all"]);
  const [sLevel, setLevel] = useState("all");
  const [sSource, setSelectedSource] = useState("all");
  const [localFilterView, setLocalFiltertView] = useState("normal"); //normal,filtered

  const initQDBFilters = (pageIdx, level, assmententtype, source, skill) => {
    let encodedJsonValues = {};
    encodedJsonValues.startover = true;
    encodedJsonValues.itemperpage = 10;
    encodedJsonValues.pagenumber = pageIdx;
    encodedJsonValues.questionabankfilter = {};
    encodedJsonValues.questionabankfilter.level = level;
    encodedJsonValues.questionabankfilter.source = source;
    encodedJsonValues.questionabankfilter.assessmenttype = assmententtype;
    encodedJsonValues.questionabankfilter.skill = skill;

    return encodedJsonValues;
  };

  useEffect(() => {
    var jasonValues = initQDBFilters(1, "all", ["all"], "all", ["all"]);
    if (globalEvaluationPage) {
      getGlobalQuestionBank(setLocalQSet, setQbCount, setQBankStats);
    } else {
      getQuestionBankForJD({ jasonValues, qhjid }, setLocalQSet, setQbCount);
      getQuestionBankForJDStats({ qhjid }, setQBankStats);
    }
  }, []);

  const applyFilter = (level, assmententtype, source, skill) => {
    var jasonValues = initQDBFilters(1, level, assmententtype, source, skill);
    //store filter values

    getQuestionBankForJD({ jasonValues, qhjid }, setLocalQSet, setQbCount);
    getQuestionBankForJDStats({ qhjid }, setQBankStats);
  };
  const handlePagination = (pgIdx) => {
    var jasonValues = initQDBFilters(
      pgIdx,
      sLevel,
      sAssessmentType,
      sSource,
      sSkill,
    );
    getQuestionBankForJD({ jasonValues, qhjid }, setLocalQSet, setQbCount);
  };

  const handleDelete = (event, indexToRemove) => {
    console.log("todelete", indexToRemove);
    //add deleted question to delete list
    localQDescDeletedList.push(localQSet[indexToRemove]);

    //now update the current list
    var localQSetNew = localQSet.filter((_, index) => index !== indexToRemove);
    setLocalQSet([...localQSetNew]);
  };

  const handleCopy = (event, indexToCopy) => {
    console.log("tocopy", indexToCopy);
    var itemToCopy;
    itemToCopy = {};
    itemToCopy.action = "ADD";
    itemToCopy.ID = null;
    itemToCopy.source = localQSet[indexToCopy].source;
    itemToCopy.questiontype = localQSet[indexToCopy].questiontype;
    itemToCopy.question = localQSet[indexToCopy].question;
    itemToCopy.multiplechoicecode = localQSet[indexToCopy].multiplechoicecode;
    itemToCopy.optiona = localQSet[indexToCopy].optiona;
    itemToCopy.optionb = localQSet[indexToCopy].optionb;
    itemToCopy.optionc = localQSet[indexToCopy].optionc;
    itemToCopy.optiond = localQSet[indexToCopy].optiond;
    itemToCopy.answer = localQSet[indexToCopy].answer;
    itemToCopy.explanation = localQSet[indexToCopy].explanation;
    itemToCopy.output = localQSet[indexToCopy].output;
    itemToCopy.level = localQSet[indexToCopy].level;
    itemToCopy.category = localQSet[indexToCopy].category;
    itemToCopy.skill = localQSet[indexToCopy].skill;
    itemToCopy.weightage = localQSet[indexToCopy].weightage;
    itemToCopy.assessmenttype = localQSet[indexToCopy].assessmenttype;
    itemToCopy.updatedby = {};
    itemToCopy.updatedby.qhuid = localQSet[indexToCopy].updatedby.qhuid;
    itemToCopy.updatedby.name = localQSet[indexToCopy].updatedby.updatedbyname;
    itemToCopy.updatedby.updatedon = localQSet[indexToCopy].updatedby.updatedon;

    const newArr = [
      ...localQSet.slice(0, indexToCopy), // empty array
      itemToCopy, // new element
      ...localQSet.slice(indexToCopy), // all original elements
    ];
    newArr[indexToCopy].ID = null;
    newArr[indexToCopy].action = "ADD";
    setLocalQSet([...newArr]);
  };
  const handleEdit = (event, indexToCopy) => {
    console.log("toedit", indexToCopy);
    const itemToCopy = localQSet[indexToCopy];
    const newItems = [...localQSet];
    newItems.splice(indexToCopy + 1, 0, itemToCopy); // Insert after original
    setLocalQSet(newItems);
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  return (
    <div className="evaluationsBank-form-wrapper">
      <div className="evaluationsBank-Stats">
        <Statistic title="Questions" value={qBankStats.totalcount} />
        <Statistic title="Entry" value={qBankStats.entrylevelcount} />
        <Statistic
          title="Intermediate"
          value={qBankStats.intermediatelevelcount}
        />
        <Statistic title="Expert" value={qBankStats.expertlevelcount} />
        <Statistic title="Custom/Upload" value={qBankStats.customcount} />
        <Statistic title="AI Generated" value={qBankStats.aicount} />
      </div>

      <div className="evaluationsBank-data">
        <div className="evaluationsBank-filters">
          <EvaluationsBankFilterSidebarForm
            qhjid={qhjid}
            ev_id={ev_id}
            evalDesc={evalDesc}
            localQDesc={localQSet}
            filterHandler={applyFilter}
            localFilterViewHandler={setLocalFiltertView}
          />
        </div>
        <div className="evaluationsBank-card-list">
          <EvaluationBankQuestionsCardList
            qhjid={qhjid}
            ev_id={ev_id}
            evalDesc={evalDesc}
            localQDesc={localQSet}
            setView={setView}
            localQHanlder={setLocalQSet}
            localQDeleteHandler={handleDelete}
            localQCopyHandler={handleCopy}
            localQEditHandler={handleEdit}
            pageHandler={handlePagination}
            totalQCount={qbCount}
            localQDescDeletedList={localQDescDeletedList}
            localFilterView={localFilterView}
            globalEvaluationPage={globalEvaluationPage}
          />
        </div>
      </div>
    </div>
  );
}
